<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="globe"/>
          {{ $t('title') }}
        </h1>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="tile">
          <div class="form-inline">
            <client-select :model="filterFormModel" attribute="client" class="mr-1 mb-1"></client-select>
            <form-input :model="filterFormModel" attribute="number" class="mr-1 mb-1" :placeholder="$t('inputNumber')"></form-input>
            <gateway-select :model="filterFormModel" attribute="gateway" class="mr-1 mb-1"></gateway-select>
            <time-range-picker :model="filterFormModel" class="mr-1 mb-1" :label="$t('createTime')"></time-range-picker>
            <button @click="load" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
            <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="c-paging clearfix">
          <div class="c-paging__count" v-if="itemCount">
            {{ $t('found', [itemCount]) }}
          </div>
          <div class="c-paging__right">
            <div class="c-paging__numbers">
              <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                            v-model="filterFormModel.page" :total-rows="itemCount"
                            :per-page="filterFormModel.pageSize" @input="load"></b-pagination>

            </div>
          </div>
        </div>
      </div>
      <div class="col-12" v-if="items.length">
        <div class="c-smart-table tile">
          <div class="row">
            <div class="col-10">
              <b class="text-info text-right">{{ $t('total') }}</b>
            </div>
            <div class="col-2"><b-spinner v-if="totalLoading" small></b-spinner><span v-else>{{ total | numFormat }}</span></div>
          </div>
          <div class="row c-smart-table__title">
            <div class="col-lg-3">{{ $t('client') }}</div>
            <div class="col-lg-2">{{ $t('number') }}</div>
            <div class="col-lg-2">{{ $t('gateway') }}</div>
            <div class="col-lg-3">{{ $t('createTime') }}</div>
            <div class="col-lg-2">{{ $t('amount') }}</div>
          </div>
          <div class="row" v-for="item in items" :key="item._id">
            <div class="col-lg-3">
              <b class="c-smart-table__label">{{ $t('client') }}: </b>
              <span>{{ item.client.companyName }} ({{ item.client.domain }})</span>
            </div>
            <div class="col-lg-2">
              <p >
                <b class="c-smart-table__label">{{ $t('phone') }}:&nbsp;</b>
                <span v-if="item.number && item.number.number">{{ item.number.number }}</span>
                <span v-else>{{$t('noPhoneNumberFound')}}</span>
              </p>
            </div>
            <div class="col-lg-2">
              <p>
                <b class="c-smart-table__label">{{ $t('gateway') }}:&nbsp;</b>
                <span>{{ item.gateway.name }} ({{item.gateway.fromDomain}})</span>
              </p>
            </div>
            <div class="col-lg-3">
              <p>
                <b class="c-smart-table__label">{{ $t('createTime') }}: </b>
                <span>{{ item.createTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
              </p>
            </div>
            <div class="col-lg-2">
              <p >
                <b class="c-smart-table__label">{{ $t('amount') }}:&nbsp;</b>
                <span>{{ item.amount | numFormat }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 text-center text-danger" v-if="!items.length">
        <span v-if="filterFormModel.page === 1 && !filterFormModel.keyword">{{ $t('notFoundCreate') }}</span>
        <span v-if="filterFormModel.page > 1 || filterFormModel.keyword">{{ $t('notFoundSearch') }}</span>
      </div>
      <div class="col-12" v-if="itemCount">
        <div class="c-paging__count" v-if="itemCount">
          {{ $t('found', [itemCount]) }}
        </div>
        <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                      v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                      @input="load">
        </b-pagination>
      </div>
    </div>
  </main>
</template>

<script>
import List from "@/mixins/List";
import ClientSelect from "../../components/ClientSelect";
import _ from 'lodash';
import TimeRangePicker from "@/components/TimeRangePicker";
import GatewaySelect from "@/components/GatewaySelect";

export default {
  components: {
    GatewaySelect,
    TimeRangePicker,
    ClientSelect
  },
  mixins: [List],
  data: function () {
    return {
      service: '/phone-number-setup-transaction',
      autoLoad: true,
      defaultFilterFormModel: {
        client: null,
        number: null,
        gateway: null
      },
      gatewayNames: [],
      total: 0,
      totalLoading: false
    }
  },
  methods: {
    search: _.debounce(function () {
      this.filterFormModel.page = 1;
      this.load();
    }, 200),
    load: _.debounce(function () {
      let loader = this.$loading.show();
      this.$service.get(this.service, {
        params: this.filterFormModel
      }).then(response => {
        this.apply(response.data);
        this.sum();
      }).catch(error => {
        if (error.response.data.message) {
          this.$swal({
            text: error.response.data.message,
            icon: 'error'
          });
        }
      }).finally(() => {
        loader.hide();
      });
    }, 200, {leading: true, trailing: false}),
    sum: function () {
      this.totalLoading = true;
      this.$bgService.get(this.service + "/sum", {params: this.filterFormModel}).then(response => {
        this.total = response.data && response.data.length > 0 ? response.data[0].total : 0;
      }).finally(()=> {
        this.totalLoading = false
      });
    },
  },
  i18n: {
    messages: {
      en: {
        title: 'Phone number setup transaction',
        inputNumber: 'Input number',
        number: 'Number',
        createTime: 'Charge time',
        amount: 'Amount',
        chooseGateway: 'Choose gateway name',
        noPhoneNumberFound: 'No phone number found'
      },
      vi: {
        title: 'Phí khởi tạo số',
        inputNumber: 'Nhập SĐT',
        number: 'Số',
        createTime: 'Tính tiền lúc',
        amount: 'Số tiền',
        chooseGateway: 'Chọn tên gateway',
        noPhoneNumberFound: 'Không tìm thấy số điện thoại'
      }
    }
  }
}
</script>